import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import HomePage from "@/pages/HomePage";
import TheHousePage from "@/pages/TheHousePage";
import GalleryPage from "@/pages/GalleryPage";
import IslandGuidePage from "@/pages/IslandGuidePage";
import LocationPage from "@/pages/LocationPage";
import BookPage from "@/pages/BookPage";
import AdminPage from "@/pages/AdminPage";
import { ScrollToTop } from "@/components/ScrollToTop";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/the-house" element={<TheHousePage />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/island-guide" element={<IslandGuidePage />} />
          <Route path="/location" element={<LocationPage />} />
          <Route path="/book" element={<BookPage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-center" />
    </div>
  );
}

export default App;
